<ms-heading [title]="title" />
<div class="list-items">
    @for (item of sports; track item.id) {
        <ms-list-item
            msTrackReferringActionDirective
            iconSize="16"
            [trackingValue]="trackingValue()"
            [cleanAfterTrack]="cleanedAfterTrack()"
            [title]="item.title"
            [icon]="item.icon"
            [href]="item.href"
            [isShowBorder]="showBorder($last)"
            (itemClicked)="onSelected(item)" />
    }
</div>
